import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a667e23e")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-2 mb-4 px-3 text-end" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "auth-btns btn-group text-center justify-center d-flex",
  role: "group",
  "aria-label": "Sign Up"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass(`btn-lg`)
  }, "Sign Up")
], -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mt-2 mb-4 px-3 text-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "auth-btns btn-group text-center justify-center d-flex",
  role: "group",
  "aria-label": "Sign Up"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass(`btn-lg`)
  }, "Sign Up and Claim Partner")
], -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "mt-2 mb-4 px-3 text-end" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Sign Up")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "auth-btns btn-group text-center justify-center d-flex",
  role: "group",
  "aria-label": "Log In"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass(`btn-lg`)
  }, "Partner Login")
], -1)
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "mt-2 mb-4 px-3 text-end" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "auth-btns btn-group text-center justify-center d-flex",
  role: "group",
  "aria-label": "Reset Password"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass(`btn-lg`)
  }, "Reset Password")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isActiveRoute(_ctx.RouteNames.SIGNUP))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.LOGIN
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.isActiveRoute(_ctx.RouteNames.SIGNUP_AND_CLAIM_PARTNER))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.LOGIN
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (_ctx.isActiveRoute(_ctx.RouteNames.LOGIN))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.SIGNUP
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_12
        ]))
      : _createCommentVNode("", true),
    (_ctx.isActiveRoute(_ctx.RouteNames.RESET_PASSWORD))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.LOGIN
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_16
        ]))
      : _createCommentVNode("", true)
  ], 64))
}